// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__nL5Ga","dark":"Navbar_dark__2+XcR","light":"Navbar_light__TBmGC","active":"Navbar_active__CPWww","link":"Navbar_link__MsWKA"};